import React, { useEffect, useState } from "react";
import { useAuth } from "./auth";
import {
  getPgByID,
  getPgDetails,
  getPgDetailsByOwner,
  getRoomDetails,
  getRoomDetailsByPg,
  updatePg,
} from "./apiService";
import { useNavigate } from "react-router-dom";

const EditPG = () => {
  const [pgname, setPgname] = useState("");
  const [rooms, setRooms] = useState("");
  const [errors, setErrors] = useState({});
  const [pgdetails, setPgdetails] = useState([]);
  const [roomdetails, setRoomdetails] = useState([]);
  const { userid, pgid } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    getPgByID(pgid)
      .then((res) => {
        // console.log(res);
        setPgname(res.pgname);
        setRooms(res.rooms);
      })
      .catch((e) => console.log(e));

    getPgDetailsByOwner(userid).then((res) => {
      setPgdetails(res);
    });

    getRoomDetailsByPg(pgid).then((res) => {
      setRoomdetails(res);
    });
  }, [pgid]);

  // console.log(userid);

  const handlePgEditSubmit = () => {
    let errors = {};
    if (!pgname) errors.pgname = "PG name is required";
    if (!rooms) errors.rooms = "Enter valid no here";

    pgdetails.forEach((pg) => {
      if (pg.pgname === pgname && pg.id !== pgid) {
        errors.pgname = "pg name already taken";
        // console.log(errors.username);
      }
      return errors;
    });

    const frooms = roomdetails.filter((room) => {
      return room.pgname === pgid;
    });

    if (Object.keys(frooms).length > rooms) {
      alert(
        "Rooms were already filled with guests. Please delete a room before reducing the room size...!!"
      );
      errors.rooms = "Not able to decrease the room size";
      return errors;
    }

    setErrors(errors);

    if (Object.keys(errors).length === 0) {
      const pg = {
        pgname: pgname,
        rooms: rooms,
        owner: userid,
      };
      // setUser(user1);

      updatePg(pg, pgid);

      setPgname("");
      setRooms("");
      navigate("/Dashboard");
    }
  };
  return (
    <div className="container">
      <div className="header">Edit PG</div>
      <div className="label">
        PGName:
        <input
          type="text"
          className="inputbox"
          name="pgname"
          defaultValue={pgname}
          // value={pgdata.pgname}
          onChange={(e) => setPgname(e.target.value)}
        />
        {errors.pgname ? (
          <div className="errortext">{errors.pgname}</div>
        ) : null}
      </div>

      <div className="label">
        No.of Rooms:
        <input
          type="text"
          className="inputbox"
          name="rooms"
          defaultValue={rooms}
          // value={rooms}
          onChange={(e) => setRooms(e.target.value)}
        />
        {errors.rooms ? <div className="errortext">{errors.rooms}</div> : null}
      </div>
      <input
        type="submit"
        className="btn-cls"
        value="Submit"
        onClick={handlePgEditSubmit}
      />
    </div>
  );
};

export default EditPG;
